<!-- 
	UpdateFormTickets
	props: User
  	role: User
	Called by @/views/Settings to allow user to update account through ClickSpace form
	Does include ticket packages
-->

<template>
  <div class="DialogInsightFormDiv" id="divForm_DIForm_709_26034" style="display:none">
    <a name="divForm_DIForm_709_26034_globalErrors_anchor"></a>
    <div class="DialogInsightGlobalErrors" id="divForm_DIForm_709_26034_globalErrors"></div>
    <div class="DialogInsightFormContainer">
      <div class="flex-container" style="background-color: azure;">
        <div class="flex flex-col grow-0 lg:w-3/4">
          <!--Start-->
          <div class="DialogInsightFormRow bg-gradient-db2">
            <div class="flex-container2">
              <div style="margin-bottom: 30px; flex-basis: 35%;">
                <img 
                  src="https://winwinstafflottery.ca/wp-content/uploads/2022/12/home-DB-heading.png"
                  alt="Discount Bundles" 
                >
              </div>
              <div style="display: flex; align-items: center; flex-basis: 65%;">
                <h2 class="royal bundle-header"> Discount Bundles – Buy Both &amp; Save $</h2>
              </div>
            </div>

            <div class="flex-container2">
              <div class="col-4 mb-2">
                <div class="card text-center" style="flex-basis: 240px; margin-left: 5px; margin-right: 5px;">
                  <div class="card-header bg-royal">
                    <input 
                      id="WinWinBundle0" 
                      v-model="selectionBundle"
                      type="radio" 
                      class="DialogInsightFormInput"
                      name="SelectedWinWinBundle" 
                      value="30"
                      @click="bundle0Handler" 
                    >
                  </div>
                  <div class="card-body d-flex flex-column justify-content-center">
                    <h4 class="card-title blue">FIVE Pack for $30</h4>
                    <p class="card-text small tan">5 WinWin Monthly +<br> 5 Quarterly 50/50<br>
                      <img class="center2 my-3" src="@/assets/save5.png" alt="Save $5" width="148" height="56">
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-4 mb-2">
                <div class="card text-center" style="flex-basis: 240px; margin-left: 5px; margin-right: 5px;">
                  <div class="card-header bg-royal">
                    <input 
                      id="WinWinBundle1" 
                      v-model="selectionBundle"
                      type="radio" 
                      class="DialogInsightFormInput"
                      name="SelectedWinWinBundle" 
                      value="47.50"
                      @click="bundle1Handler" 
                    >
                  </div>
                  <div class="card-body d-flex flex-column justify-content-center">
                    <h4 class="card-title blue">TEN Pack for $47.50</h4>
                    <p class="card-text small tan">10 WinWin Monthly +<br> 10 Quarterly 50/50<br>
                      <img class="center2 my-3" src="@/assets/save75.png" alt="Save $7.50" width="154" height="55">
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-4 mb-2">
                <div class="card text-center" style="flex-basis: 240px; margin-left: 5px; margin-right: 5px;">
                  <div class="card-header bg-royal">
                    <input 
                      id="WinWinBundle2" 
                      v-model="selectionBundle"
                      type="radio" 
                      class="DialogInsightFormInput"
                      name="SelectedWinWinBundle" 
                      value="65"
                      @click="bundle2Handler" 
                    >
                  </div>
                  <div class="card-body d-flex flex-column justify-content-center">
                    <h4 class="card-title blue">TWENTY Pack for $65</h4>
                    <p class="card-text small tan">20 WinWin Monthly +<br> 20 Quarterly 50/50<br>
                      <img class="center2 my-3" src="@/assets/save10.png" alt="Save $10" width="150" height="55">
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div 
              id="clearBundle"
              class="clearSelection button-clear royal center" 
              style="background: linear-gradient(115deg,rgba(153,135,95,1) 0%,rgba(231,214,164,1) 50%,rgba(169,151,109,1) 100%)!important;"
              @click="clearBundleSelection"
            >
              <strong>CLEAR DISCOUNT BUNDLE SELECTION</strong>
            </div>
          </div>

          <a name="MainWinWinLotterySectionStart"></a>
          <div class="DialogInsightFormRow bg-gradient-royal">
            <div id="ticket-packages" class="DialogInsightInputContainer">
              <div id="DIField_26034_f_NewMainTicketPackage">
                <div id="WinWinStaffLotteryTickets" class="mb-5 clearfix">
                  <div class="flex-container2">
                    <div style="margin-bottom: 30px; flex-basis: 40%;">
                      <img 
                        src="https://winwinstafflottery.ca/wp-content/uploads/2022/12/home-WW-heading-1.png"
                        alt="Discount Bundles"
                      >
                    </div>
                    <div style="display: flex; align-items: center; flex-basis: 60%;">
                      <h2 class="gold-ombre bundle-header">WinWin Staff Lottery Monthly Draw</h2>
                    </div>
                  </div>

                  <div class="flex-container2">
                    <div class="col-3 mb-2">
                      <div class="card text-center" style="min-height: 205px; margin-left: 5px; margin-right: 5px;">
                        <div class="card-header bg-gold-ombre2"><input type="radio"
                            v-on:change="bundleComponentValidationHandler" class="DialogInsightFormInput"
                            name="DIField_26034_f_NewMainTicketPackage" id="DIField_26034_f_NewMainTicketPackage0"
                            ticket-name="1" data-price="10" value="10" v-model="selectionMain"></div>
                        <div class="card-body d-flex flex-column justify-content-center">
                          <h4 class="card-title blue">1 for $10</h4>
                          <p class="d-block d-md-none card-text small tan">($10/each)</p>

                          <!-- <div class="d-none d-md-block" style="margin-bottom:5px;"></div> -->
                        </div>
                      </div>
                    </div>

                    <div class="col-3 mb-2">
                      <div class="card text-center" style="min-height: 205px; margin-left: 5px; margin-right: 5px;">
                        <div class="card-header bg-gold-ombre2"><input type="radio"
                            v-on:change="bundleComponentValidationHandler" class="DialogInsightFormInput"
                            name="DIField_26034_f_NewMainTicketPackage" id="DIField_26034_f_NewMainTicketPackage1"
                            ticket-name="5" data-price="20" value="20" v-model="selectionMain"></div>
                        <div class="card-body d-flex flex-column justify-content-center">
                          <h4 class="card-title blue">5 for $20</h4>
                          <p class="d-block d-md-none card-text small tan">($4/each)</p>

                          <div class="d-none d-md-block" style="margin-bottom:5px;"></div>
                        </div>
                      </div>
                    </div>

                    <div class="col-3 mb-2">
                      <div class="card text-center" style="min-height: 205px; margin-left: 5px; margin-right: 5px;">
                        <div class="card-header bg-gold-ombre2"><input type="radio"
                            v-on:change="bundleComponentValidationHandler" class="DialogInsightFormInput"
                            name="DIField_26034_f_NewMainTicketPackage" id="DIField_26034_f_NewMainTicketPackage2"
                            ticket-name="10" data-price="30" value="30" v-model="selectionMain"></div>
                        <div class="card-body d-flex flex-column justify-content-center">
                          <h4 class="card-title blue">10 for $30</h4>
                          <p class="d-block d-md-none card-text small tan">($3/each)</p>

                          <div class="d-none d-md-block" style="margin-bottom:5px;"></div>
                        </div>
                      </div>
                    </div>

                    <div class="col-3 mb-2" id="DIField_26034_f_NewMainTicketPackage4_Option" v-show="false">
                      <div class="card text-center" style="min-height: 205px; margin-left: 5px; margin-right: 5px;">
                        <div class="card-header bg-gold-ombre2"><input type="radio"
                            v-on:change="bundleComponentValidationHandler" class="DialogInsightFormInput"
                            name="DIField_26034_f_NewMainTicketPackage" id="DIField_26034_f_NewMainTicketPackage4"
                            ticket-name="20" data-price="40" value="40" v-model="selectionMain"></div>
                        <div class="card-body d-flex flex-column justify-content-center">
                          <h4 class="card-title blue">20 for $40</h4>
                          <p class="d-block d-md-none card-text small tan">($2/each)</p>

                          <div class="d-none d-md-block" style="margin-bottom:5px;"></div>
                        </div>
                      </div>
                    </div>

                    <div class="col-3 mb-2" v-show="selectionBundle == '65'"
                      id="DIField_26034_f_NewMainTicketPackage3_Option">
                      <div class="card text-center" style="min-height: 205px; margin-left: 5px; margin-right: 5px;">
                        <div class="card-header bg-gold-ombre2"><input type="radio"
                            v-on:change="bundleComponentValidationHandler" class="DialogInsightFormInput"
                            name="DIField_26034_f_NewMainTicketPackage" id="DIField_26034_f_NewMainTicketPackage3"
                            ticket-name="20" data-price="35" value="35" v-model="selectionMain"></div>
                        <div class="card-body d-flex flex-column justify-content-center">
                          <h4 class="card-title blue">20 for $35</h4>
                          <img class="center" src="@/assets/save5.png" alt="Save $5" width="148" height="56">
                          <div class="d-none d-md-block" style="margin-bottom:5px;"></div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div class="clearSelection button-clear center" v-if="selectionBundle == ''"
                  @click="clearMainSelection" id="clearMain"
                  style="background: linear-gradient(125deg, #1A1F56, #040707, #1A1F56)!important;"><strong>CLEAR WINWIN
                    MONTHLY TICKET SELECTION</strong></div>
                <div class="DialogInsightErrorContainer" id="DIField_26034_f_NewMainTicketPackage_errors"></div>

              </div>
            </div>
          </div>



          <a name="5050QuarterlyCashSectionStart"></a>
          <div class="DialogInsightFormRow bg-gradient-qc">

            <div class="DialogInsightInputContainer">
              <div id="DIField_26034_f_New5050TicketPackage">

                <div id="QuarterlyCash5050Tickets" class="mb-5 clearfix">

                  <div class="flex-container2">
                    <div style="margin-bottom: 30px; flex-basis: 40%;">
                      <img src="https://winwinstafflottery.ca/wp-content/uploads/2022/12/home-QC-heading.png"
                        alt="Discount Bundles">
                    </div>
                    <div style="display: flex; align-items: center; flex-basis: 60%;">
                      <h2 class="royal bundle-header">Quarterly Cash 50/50 Draw</h2>
                    </div>
                  </div>

                  <div class="flex-container2">

                    <div class="col-3 mb-2">
                      <div class="card text-center" style="min-height: 205px; margin-left: 5px; margin-right: 5px;">
                        <div class="card-header bg-royal"><input type="radio"
                            v-on:change="bundleComponentValidationHandler" class="DialogInsightFormInput"
                            name="DIField_26034_f_New5050TicketPackage" id="DIField_26034_f_New5050TicketPackage0"
                            ticket-name="1" data-price="5" value="5" v-model="selection50"></div>
                        <div class="card-body d-flex flex-column justify-content-center">
                          <h4 class="card-title blue">1 for $5</h4>
                          <p class="card-text small tan">($5/each)</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-3 mb-2" id="DIField_26034_f_New5050TicketPackage2_Option"
                      v-show="selectionBundle != '30'">
                      <div class="card text-center" style="min-height: 205px; margin-left: 5px; margin-right: 5px;">
                        <div class="card-header bg-royal"><input type="radio"
                            v-on:change="bundleComponentValidationHandler" class="DialogInsightFormInput"
                            name="DIField_26034_f_New5050TicketPackage" id="DIField_26034_f_New5050TicketPackage2"
                            ticket-name="5" data-price="15" value="15" v-model="selection50"></div>
                        <div class="card-body d-flex flex-column justify-content-center">
                          <h4 class="card-title blue">5 for $15</h4>
                          <p class="card-text small tan">($3/each)</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-3 mb-2" id="DIField_26034_f_New5050TicketPackage1_Option"
                      v-show="selectionBundle == '30'">
                      <div class="card text-center" style="min-height: 205px; margin-left: 5px; margin-right: 5px;">
                        <div class="card-header bg-royal"><input type="radio"
                            v-on:change="bundleComponentValidationHandler" class="DialogInsightFormInput"
                            name="DIField_26034_f_New5050TicketPackage" id="DIField_26034_f_New5050TicketPackage1"
                            ticket-name="5" data-price="10" value="10" v-model="selection50"></div>
                        <div class="card-body d-flex flex-column justify-content-center">
                          <h4 class="card-title blue">5 for $10</h4>
                          <img class="center" src="@/assets/save5.png" alt="Save $5" width="148" height="56">
                        </div>
                      </div>
                    </div>

                    <div class="col-3 mb-2" id="DIField_26034_f_New5050TicketPackage4_Option"
                      v-show="selectionBundle != '47.50'">
                      <div class="card text-center" style="min-height: 205px; margin-left: 5px; margin-right: 5px;">
                        <div class="card-header bg-royal"><input type="radio"
                            v-on:change="bundleComponentValidationHandler" class="DialogInsightFormInput"
                            name="DIField_26034_f_New5050TicketPackage" id="DIField_26034_f_New5050TicketPackage4"
                            ticket-name="10" data-price="25" value="25" v-model="selection50"></div>
                        <div class="card-body d-flex flex-column justify-content-center">
                          <h4 class="card-title blue">10 for $25</h4>
                          <p class="card-text small tan">($2.50/each)</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-3 mb-2" id="DIField_26034_f_New5050TicketPackage3_Option"
                      v-show="selectionBundle == '47.50'">
                      <div class="card text-center" style="min-height: 205px; margin-left: 5px; margin-right: 5px;">
                        <div class="card-header bg-royal"><input type="radio"
                            v-on:change="bundleComponentValidationHandler" class="DialogInsightFormInput"
                            name="DIField_26034_f_New5050TicketPackage" id="DIField_26034_f_New5050TicketPackage3"
                            ticket-name="10" data-price="17.50" value="17.50" v-model="selection50"></div>
                        <div class="card-body d-flex flex-column justify-content-center">
                          <h4 class="card-title blue">10 for $17.5</h4>
                          <img class="center" src="@/assets/save75.png" alt="Save $7.50" width="154" height="55">
                        </div>
                      </div>
                    </div>

                    <div class="col-3 mb-2" id="DIField_26034_f_New5050TicketPackage6_Option"
                      v-show="selectionBundle != '65'">
                      <div class="card text-center" style="min-height: 205px; margin-left: 5px; margin-right: 5px;">
                        <div class="card-header bg-royal"><input type="radio"
                            v-on:change="bundleComponentValidationHandler" class="DialogInsightFormInput"
                            name="DIField_26034_f_New5050TicketPackage" id="DIField_26034_f_New5050TicketPackage6"
                            ticket-name="20" data-price="35" value="35" v-model="selection50"></div>
                        <div class="card-body d-flex flex-column justify-content-center">
                          <h4 class="card-title blue">20 for $35</h4>
                          <p class="card-text small tan">($1.75/each)</p>
                        </div>
                      </div>
                    </div>

                    <div class="col-3 mb-2" id="DIField_26034_f_New5050TicketPackage5_Option"
                      v-show="selectionBundle == '65'">
                      <div class="card text-center" style="min-height: 205px; margin-left: 5px; margin-right: 5px;">
                        <div class="card-header bg-royal"><input type="radio"
                            v-on:change="bundleComponentValidationHandler" class="DialogInsightFormInput"
                            name="DIField_26034_f_New5050TicketPackage" id="DIField_26034_f_New5050TicketPackage5"
                            ticket-name="20" data-price="30" value="30" v-model="selection50"></div>
                        <div class="card-body d-flex flex-column justify-content-center">
                          <h4 class="card-title blue">20 for $30</h4>
                          <img class="center" src="@/assets/save5.png" alt="Save $5" width="148" height="56">
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
                <div class="clearSelection button-clear royal center" v-if="selectionBundle == ''"
                  @click="clear50Selection"
                  style="background: linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd)!important;"
                  id="clearFifty"><strong>CLEAR QUARTERLY CASH 50/50 TICKET SELECTION</strong></div>
                <div class="DialogInsightErrorContainer" id="DIField_26034_f_New5050TicketPackage_errors"></div>

              </div>
            </div>
          </div>


          <div class="DialogInsightFormRow" style="display: none;">
            <div class="DialogInsightLabel_AboveField">EMail *</div>
            <div class="DialogInsightInputContainer">
              <input type="text" class="DialogInsightFormInput" id="DIField_26034_f_EMail" maxlength="125"
                v-model="email" readonly />
              <div class="DialogInsightErrorContainer" id="DIField_26034_f_EMail_errors"></div>
            </div>
          </div>
          <div class="DialogInsightFormRow" style="display: none;">
            <div class="DialogInsightLabel_AboveField">Employee ID *</div>
            <div class="DialogInsightInputContainer">
              <input type="text" class="DialogInsightFormInput" id="DIField_26034_f_EmployeeID" maxlength="8"
                v-model="employeeId" readonly />
              <div class="DialogInsightErrorContainer" id="DIField_26034_f_EmployeeID_errors"></div>
            </div>
          </div>

          <div class="DialogInsightFormRow" style="display: none;">
            <div class="DialogInsightLabel_AboveField">Deduction Code Main - New</div>
            <div class="DialogInsightInputContainer">
              <input type="text" class="DialogInsightFormInput" id="DIField_26034_f_DeductionCodeMainNew" maxlength="30"
                v-model="deductionCodeMain" />
              <div class="DialogInsightErrorContainer" id="DIField_26034_f_DeductionCodeMainNew_errors"></div>
            </div>
          </div>
          <div class="DialogInsightFormRow" style="display: none;">
            <div class="DialogInsightLabel_AboveField">Deduction Code 5050 - New</div>
            <div class="DialogInsightInputContainer">
              <input type="text" class="DialogInsightFormInput" id="DIField_26034_f_DeductionCode5050New" maxlength="30"
                v-model="deductionCode50" />
              <div class="DialogInsightErrorContainer" id="DIField_26034_f_DeductionCode5050New_errors"></div>
            </div>
          </div>

          <div class="DialogInsightFormSubmit" v-if="selectionTotal != 0">
            <button class="button-submit royal center2" type="button"
              onclick="DI.Forms.Optin.Client.GetOptinForm('DIForm_709_26034').Submit(this); return false;">Submit</button>
            <img class="DialogInsightFormSubmitLoader"
              src="https://cdn.dialoginsight.com/DI/Forms/resources/AjaxBlackLoader.gif" />
          </div>

          <br>

          <!--End-->




        </div>

        <div class="sticky lg:w-1/4 bg-gradient-royal" style="margin-left: 10px; margin-right: 10px;">

          <div class="d-none d-md-block" style="margin-top:140px;"></div>

          <div class="fancy-title title-center" style="text-align: center!important;">
            <h2 class="blue t600 lh1-0 header-summary">Your Order Summary</h2>
          </div>

          <!-- CALCULATION RESULTS -->

          <div class="pricing-box pricing-extended clearfix p-3 mb-0">

            <div class="pricing-desc py-3 px-2">
              <div class="pricing-title">
                <h3 class="text-16 ls-0 lh1-3">YOUR TICKET SELECTION INCLUDES:</h3>
              </div>

            </div>

            <ul class="iconlist mb-0 ml-0">
              <li class="h6 pb-1 ls-1"><span class="winwin-value">{{ selectionMainTicket }} </span> WinWin Staff Lottery
                Monthly Draw Tickets</li>
              <li class="h6 pb-1 ls-1"><span class="quarterlycash-value">{{ selection50Ticket }} </span> Quarterly Cash
                50|50 Tickets</li>
            </ul>



            <div class="pricing-action-area">
              <div class="pricing-meta blue">YOUR TOTAL PER PAY PERIOD</div>
              <div class="pricing-price pb-0 blue">
                <h2 class="total-price h1 fw-semibold">$ {{ selectionTotal }}</h2>

              </div>
            </div>
            <br>

            <center>
              <div class="button2 royal" @click="clearBothSelection"
                style="background:linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd)!important;"
                id="buttonClearCart">CLEAR CART</div>
            </center>

            <br>

            <center>

              <!--
              <div id="bundleMessage0" style="display: none;">
                  <p>You are eligible for a discount bundle with your current selection. Click the button below to select the discount bundle and save $5.00.  
                  </p>
                  <div class="button2 royal" style="background:linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd)!important;" id="buttonBundle0">Change to FIVE Pack</div>
              </div>

              <div id="bundleMessage1" style="display: none;">
                  <p>You are eligible for a discount bundle with your current selection. Click the button below to select the discount bundle and save $7.50.  
                  </p>
                  <div class="button2 royal" style="background:linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd)!important;" id="buttonBundle1">Change to TEN Pack</div>
              </div>

              <div id="bundleMessage2" style="display: none;">
                  <p>You are eligible for a discount bundle with your current selection. Click the button below to select the discount bundle and save $10.00.  
                  </p>
                  <div class="button2 royal" style="background:linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd)!important;" id="buttonBundle2">Change to TWENTY Pack</div>
              </div>
              -->

              <div id="bundleMessage0" style="display: none;">
                <p>A discount of $5.00 has been automatically applied to your cart based on your selection.
                </p>
              </div>

              <div id="bundleMessage1" style="display: none;">
                <p>A discount of $7.50 has been automatically applied to your cart based on your selection.
                </p>
              </div>

              <div id="bundleMessage2" style="display: none;">
                <p>A discount of $10.00 has been automatically applied to your cart based on your selection.
                </p>
              </div>


              <div id="mainOnlyMessage" style="display: none;">
                <p>Would you also like to purchase Quarterly Cash 50/50 tickets? Click the button below to navigate to
                  that section.
                </p>
                <div class="button2 royal"
                  style="background:linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd)!important;"
                  id="mainOnlyButton">Quarterly Cash 50/50</div>
              </div>

              <div id="5050OnlyMessage" style="display: none;">
                <p>Would you also like to purchase Monthly WinWin Staff Lottery tickets? Click the button below to
                  navigate to that section.
                </p>
                <div class="button2 royal"
                  style="background:linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd)!important;"
                  id="5050OnlyButton">Monthly WinWin Lottery</div>
              </div>

              <div id="main5OnlyMessage" style="display: none;">
                <p>You are eligible for a discount bundle with your current selection. Click the button below to add
                  FIVE Quarterly Cash 50/50 tickets for $10 and save $5.
                </p>
                <div class="button2 royal"
                  style="background:linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd)!important;"
                  id="buttonBundle0FromMain">Change to FIVE Pack</div>
              </div>

              <div id="main10OnlyMessage" style="display: none;">
                <p>You are eligible for a discount bundle with your current selection. Click the button below to add TEN
                  Quarterly Cash 50/50 tickets for $17.50 and save $7.50.
                </p>
                <div class="button2 royal"
                  style="background:linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd)!important;"
                  id="buttonBundle1FromMain">Change to TEN Pack</div>
              </div>

              <div id="main20OnlyMessage" style="display: none;">
                <p>You are eligible for a discount bundle with your current selection. Click the button below to add
                  TWENTY Quarterly Cash 50/50 tickets for $25 and save $10.
                </p>
                <div class="button2 royal"
                  style="background:linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd)!important;"
                  id="buttonBundle2FromMain">Change to TWENTY Pack</div>
              </div>

              <div id="50505OnlyMessage" style="display: none;">
                <p>You are eligible for a discount bundle with your current selection. Click the button below to add
                  FIVE Monthly WinWin Staff Lottery tickets for $15 and save $5.
                </p>
                <div class="button2 royal"
                  style="background:linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd)!important;"
                  id="buttonBundle0From5050">Change to FIVE Pack</div>
              </div>

              <div id="505010OnlyMessage" style="display: none;">
                <p>You are eligible for a discount bundle with your current selection. Click the button below to add TEN
                  Monthly WinWin Staff Lottery tickets for $22.50 and save $7.50.
                </p>
                <div class="button2 royal"
                  style="background:linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd)!important;"
                  id="buttonBundle1From5050">Change to TEN Pack</div>
              </div>

              <div id="505020OnlyMessage" style="display: none;">
                <p>You are eligible for a discount bundle with your current selection. Click the button below to add
                  TWENTY Monthly WinWin Staff Lottery tickets for $30 and save $10.
                </p>
                <div class="button2 royal"
                  style="background:linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd)!important;"
                  id="buttonBundle2From5050">Change to TWENTY Pack</div>
              </div>

            </center>
            <br>

          </div>
        </div>
      </div>

    </div>

    <div class="DialogInsightFormSuccessDiv" id="divForm_DIForm_709_26034_success" style="padding:10px; display: none;">
      <div
        style="background-color: #1A1F56;background-image: url('images/enrollment/442726269.jpg'); background-blend-mode: multiply;"
        class="py-0">
        <div class="container clearfix">
          <div class="emphasis-title center bottommargin-lg" data-animate="pulse">
            <br>
            <h2 class="gold nomargin eloquent t700">
              CHANGES CONFIRMED
            </h2>
          </div>
        </div>

        <div class="container clearfix center">
          <div class="row">
            <div class="col col-lg-2" />

            <div class="col-8 padding-goldbox mb-0 divcenter">
              <p class="mb-0 white text-18 t500 lh1-3">
                You have successfully submitted a request to change your current ticket packages. Changes to deductions
                will occur the next available pay period.
              </p>

            </div>
          </div>
          <div class="row">
            <div class="col">
              <router-link to="/user">
                <CustomButton>VIEW MY PROFILE</CustomButton>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>




</template>

<script>
import { onMounted } from "@vue/runtime-core";

import CustomButton from "@/components/CustomButton";
import Loading from "@/components/Loading";


export default {
  name: "UpdateFormTickets",
  components: {
    CustomButton,
    Loading,
  },
  props: ["user"],
  setup() {
    onMounted(() => {
      // ClickSpace form requirement
      /*
      DI.Forms.Optin.Dom.onReady(function() {
        try {
 
        
        DI.Forms.Optin.Client.InitOptinForm({
          formIdent: "DIForm_709_18535",
          culture: "en-US",
          idBaseDiv: "divForm_DIForm_709_18535",
          recaptchaSiteKey: "",
          fields: [	{"name":"f_NewMainTicketPackage","lbl":"Select Your New Main Ticket Package","id":"DIField_18535_f_NewMainTicketPackage","validators":["required"],"inputType":"radio"},
      {"name":"f_New5050TicketPackage","lbl":"Select Your New 50/50 Ticket Package","id":"DIField_18535_f_New5050TicketPackage","validators":[],"inputType":"radio"},
      {"name":"f_EmployeeID","lbl":"Employee ID","id":"DIField_18535_f_EmployeeID","validators":["required"]},
      {"name":"f_EMail","lbl":"EMail","id":"DIField_18535_f_EMail","validators":["required","email"]}],
          fieldValues: {},
          errorMessages: {
            general: "Error in form.",
            required: "The field {0} is required.",
            dataType: "The datatype for {0} is invalid.",
            min: "The minimum value for {0} is {1}.",
            max: "The maximum value for {0} is {1}.",
            interval: "The value for {0} must be between {1} and {2}.",
            inputMask: "The value for {0} does not match the input format.",
            updateDupeKey:
              "Update could not be performed as this identifier already exists.",
            checkInlineErrors: "Please correct the errors below.",
          },
          idSuccessDiv: "divForm_DIForm_709_18535_success",
          mode: DI.Forms.Optin.Client.EnumOptinMode.Optin,
          url: "//app.dialoginsight.com/A/WF.ashx",
          idWorkflow: 15241,
          wfKey: "hip4ve",
          nodeKey: "Optin",
          visible: true,
        });
        }
        catch (err) {}
      });
      */

      DI.Forms.Optin.Dom.onReady(function () {
        DI.Forms.Optin.Client.InitOptinForm({
          formIdent: 'DIForm_709_26034',
          culture: 'en-US',
          idBaseDiv: 'divForm_DIForm_709_26034',
          recaptchaSiteKey: '',
          fields: [
            {"name":"f_NewMainTicketPackage","lbl":"Select Your New Main Ticket Package","id":"DIField_26034_f_NewMainTicketPackage","validators":[],"inputType":"radio"},
            {"name":"f_New5050TicketPackage","lbl":"Select Your New 50/50 Ticket Package","id":"DIField_26034_f_New5050TicketPackage","validators":[],"inputType":"radio"},
            {"name":"f_EMail","lbl":"EMail","id":"DIField_26034_f_EMail","validators":["required","email"]},
            {"name":"f_EmployeeID","lbl":"Employee ID","id":"DIField_26034_f_EmployeeID","validators":["required"]},
            {"name":"f_DeductionCodeMainNew","lbl":"Deduction Code Main - New","id":"DIField_26034_f_DeductionCodeMainNew","validators":[]},
            {"name":"f_DeductionCode5050New","lbl":"Deduction Code 5050 - New","id":"DIField_26034_f_DeductionCode5050New","validators":[]}
          ],
          fieldValues: {},
          errorMessages: {"general":"Error in form.","required":"The field {0} is required.","dataType":"The datatype for {0} is invalid.","min":"The minimum value for {0} is {1}.","max":"The maximum value for {0} is {1}.","interval":"The value for {0} must be between {1} and {2}.","inputMask":"The value for {0} does not match the input format.","updateDupeKey":"Update could not be performed as this identifier already exists.","checkInlineErrors":"Please correct the errors below."} ,
          idSuccessDiv: 'divForm_DIForm_709_26034_success',
          mode: DI.Forms.Optin.Client.EnumOptinMode.Optin,
          url: '//app.dialoginsight.com/A/WF.ashx',
          idWorkflow: 22043,
          wfKey: 'bcseQA',
          nodeKey: 'Optin',
          visible: true
            
        });
      });


    });
  },
  data(props) {
    return {
      company: props.user.apiData.Profile.PayrollSelection,
      mainPackage:
        props.user.apiData.Profile.CurrentMainTicketPackage ||
        props.user.apiData.Profile.NewMainTicketPackage,
      fiftyPackage:
        props.user.apiData.Profile.Current5050TicketPackage ||
        props.user.apiData.Profile.New5050TicketPackage,
      mobilePhone: props.user.apiData.Profile.MobilePhone,
      homePhone: props.user.apiData.Profile.HomePhone,
      formCount: 0,
      employeeId: props.user.apiData.Profile.EmployeeId,
      email: props.user.apiData.Profile.EmailAddress,
      selectionMain: "",
      selection50: "",
      selectionBundle: "",
    };
  },
  computed: {
    selectionTotal: function () {
      return Number(this.selectionMain) + Number(this.selection50);
    },
    selectionMainTicket: function () {
      if (this.selectionMain == "10") {
        return "1";
      }
      else if (this.selectionMain == "20") {
        return "5";
      }
      else if (this.selectionMain == "30") {
        return "10";
      }
      else if (this.selectionMain == "40") {
        return "20";
      }
      else if (this.selectionMain == "35") {
        return "20";
      }
      else {
        return "0";
      }
    },
    selection50Ticket: function () {
      if (this.selection50 == "5") {
        return "1";
      }
      else if (this.selection50 == "15") {
        return "5";
      }
      else if (this.selection50 == "10") {
        return "5";
      }
      else if (this.selection50 == "25") {
        return "10";
      }
      else if (this.selection50 == "17.50") {
        return "10";
      }
      else if (this.selection50 == "35") {
        return "20";
      }
      else if (this.selection50 == "30") {
        return "20";
      }
      else {
        return "0";
      }
    },
    deductionCodeMain: function () {
      if (this.selectionMain == "10") {
        return "WIN3";
      }
      else if (this.selectionMain == "20") {
        return "WIN8";
      }
      else if (this.selectionMain == "30") {
        return "WIN15";
      }
      else if (this.selectionMain == "35") {
        return "WIN1";
      }
      else if (this.selectionMain == "40") {
        return "WIN40";
      }
      else {
        return "";
      }
    },
    deductionCode50: function () {
      if (this.selection50 == "") {
        return "";
      }
      else {
        return "WIN50";
      }
    },

  },
  methods: {
    clearMainSelection: function () {
      this.selectionMain = "";
    },
    clear50Selection: function () {
      this.selection50 = "";
    },
    clearBothSelection: function () {
      this.selectionMain = "";
      this.selection50 = "";
      this.selectionBundle = "";
    },
    clearBundleSelection: function () {
      this.selectionBundle = "";
      if ((this.selectionMain == "20") && (this.selection50 == "10")) {
        this.selectionMain = "";
        this.selection50 = "";
      }
      if ((this.selectionMain == "30") && (this.selection50 == "17.50")) {
        this.selectionMain = "";
        this.selection50 = "";
      }
      if ((this.selectionMain == "35") && (this.selection50 == "30")) {
        this.selectionMain = "";
        this.selection50 = "";
      }
    },
    bundle0Handler: function () {
      this.selectionMain = "20";
      this.selection50 = "10";
    },
    bundle1Handler: function () {
      this.selectionMain = "30";
      this.selection50 = "17.50";
    },
    bundle2Handler: function () {
      this.selectionMain = "35";
      this.selection50 = "30";
    },
    bundleComponentValidationHandler: function () {
      //console.log(this.selectionMain);
      //console.log(this.selection50);
      /*
      if (!(((this.selectionMain == "20") && (this.selection50 == "10")) || ((this.selectionMain == "30") && (this.selection50 == "17.50")) ||((this.selectionMain == "35") && (this.selection50 == "30")))) {
        this.selectionBundle = "";
        
        if (this.selectionMain == "35") {
          this.selectionMain = "40";  
        }
 
        if (this.selection50 == "10") {
          this.selection50 = "15";
        }
 
        if (this.selection50 == "17.50") {
          this.selection50 = "25";
        }
 
        if (this.selection50 == "30") {
          this.selection50 = "35";
        }
 
      }
 
      if ((this.selectionMain == "20") && (this.selection50 == "15")) {
        this.selectionBundle = "30";
        this.selection50 = "10";
      }
 
      if ((this.selectionMain == "30") && (this.selection50 == "25")) {
        this.selectionBundle = "47.50";
        this.selection50 = "17.50";
      }
 
      if ((this.selectionMain == "40") && (this.selection50 == "35")) {
        this.selectionBundle = "65";
        this.selectionMain = "35";
        this.selection50 = "30";
      }
      */

    },

  },
};

</script>

<style lang="scss">
@import "../assets/styles.scss";


//@import "https://winwinstafflottery.ca/enroll/css/bootstrap.css";
//@import "https://winwinstafflottery.ca/enroll/css/enrollment2023.css";
//@import "https://winwinstafflottery.ca/enroll/css/responsive.css";

// @import "https://winwinstafflottery.ca/enroll/css/custom2023.css?v=1.4>";

/*
    @import "https://use.typekit.net/itr6qee.css";
    @import "https://winwinstafflottery.ca/enroll/css/bootstrap.css";
    @import "https://winwinstafflottery.ca/enroll/style.css?v=<?=time();?>";
    @import "https://winwinstafflottery.ca/enroll/css/swiper.css";
    @import "https://winwinstafflottery.ca/enroll/css/dark.css";
    @import "https://winwinstafflottery.ca/enroll/css/font-icons.css";
   
    @import "https://winwinstafflottery.ca/enroll/css/animate.css";
    @import "https://winwinstafflottery.ca/enroll/css/magnific-popup.css";
    @import "https://winwinstafflottery.ca/enroll/css/custom2023.css?v=1.4>";
  */

/*
    @import "https://winwinstafflottery.ca/enroll/css/table.css";
    @import "https://winwinstafflottery.ca/enroll/css/colors.css";
    @import "https://winwinstafflottery.ca/enroll/css/enrollment2023.css";
    @import "https://winwinstafflottery.ca/enroll/css/responsive.css";
  
  */


.pricing-price {
  position: relative;
  padding: 1.5rem 0;
  color: #333;
  font-size: 2.5rem;
  line-height: 1;
}

/*
  .pricing-price .price-unit {
    display: inline-block;
    vertical-align: top;
    margin: 7px 3px 0 0;
    font-size: 28px;
    font-weight: normal;
  }
  
  .pricing-price .price-tenure {
    vertical-align: baseline;
    font-size: 1rem;
    font-weight: normal;
    letter-spacing: 1px;
    color: #999;
    margin: 0 0 0 3px;
  }
  */

.pricing-extended {
  background-color: #FFF;
  text-align: left;
}

.pricing-extended .pricing-title {
  background-color: transparent;
  padding-top: 0;
}

.pricing-extended .pricing-features {
  border: 0;
  background-color: transparent;
}

.pricing-extended .pricing-action-area {
  border-left: 1px solid rgba(0, 0, 0, 0.05);
  background-color: #F9F9F9;
  padding: 30px;
  text-align: center;
}

.pricing-extended .pricing-action-area .pricing-price,
.pricing-extended .pricing-action-area .pricing-action {
  padding: 0;
}

.pricing-extended .pricing-action-area .pricing-price {
  padding-bottom: 20px;
}

.pricing-extended .pricing-action-area .pricing-price::after {
  display: none;
}

.pricing-extended .pricing-action-area .pricing-price span.price-tenure {
  display: block;
  margin: 10px 0 0 0;
  font-weight: 300;
  text-transform: uppercase;
  font-size: 0.875rem;
}

.pricing-extended .pricing-meta {
  color: #999;
  font-weight: 300;
  font-size: 0.875rem;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding-bottom: 10px;
}

.pricing-box {
  border-color: rgba(255, 255, 255, 0.1);
  background-color: rgb(231, 214, 164);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  padding: 10px;
}

.header-summary {
  font-weight: 600 !important;
  line-height: 1 !important;
  font-size: 30px;
  margin: 0 0 30px;
  font-family: poppins, sans-serif;
}

.button-submit {
  background-color: #ffd36c !important;
  color: #E5D876;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  border: 1px #1a1f56 solid;
  text-shadow: 0px 0px 0px rgb(0 0 0 / 20%);
}

.button-submit:hover {
  /*				background-color: #1a1f56!important;*/
  color: #33ccff !important;
  box-shadow: var(--shadow-elevation-medium);
}

.button-clear {
  display: inline-block;
  position: relative;
  cursor: pointer;
  outline: none;
  margin: 5px;
  padding: 0 22px;
  font-size: 14px;
  line-height: 36px;
  font-weight: 500;
  text-transform: uppercase;
  text-align: center !important;
  letter-spacing: 1px;
  border: 1px #E5D876 solid;
  text-shadow: 0px 0px 0px rgb(0 0 0 / 20%);
}

.button-clear:hover {
  /*				background-color: #1a1f56!important;*/
  color: #33ccff !important;
  box-shadow: var(--shadow-elevation-medium);
}

/*
        .clearSelection {
          text-transform: uppercase;
          background-color: #eaeaea;
          cursor: pointer;
          box-shadow: var(--shadow-elevation-low);
        }
  
        .clearSelection:hover, .process-btn:hover {
          background-color: #1a1f56!important;
          color: #eaeaea!important;
          box-shadow: var(--shadow-elevation-medium);
        }
  
        */


.bg-gradient-royal {
  background: linear-gradient(125deg, #1A1F56, #040707, #1A1F56) !important;
  border: 2px solid #ffd36c;
  padding: 30px !important;
  margin-bottom: 50px;
  box-shadow: 0px 0px 50px 0px rgb(0 0 0 / 50%);
}


.bg-gradient-db2 {
  background: linear-gradient(115deg, rgba(153, 135, 95, 1) 0%, rgba(231, 214, 164, 1) 50%, rgba(169, 151, 109, 1) 100%) !important;
  border: 2px solid #ffd36c;
  padding: 30px !important;
  margin-bottom: 50px;
  box-shadow: 0px 0px 50px 0px rgb(0 0 0 / 50%);
}

.bg-gold-ombre2 {
  background: rgb(153, 153, 102);
  background: linear-gradient(105deg, rgba(153, 135, 95, 1) 0%, rgba(231, 214, 164, 1) 50%, rgba(169, 151, 109, 1) 100%);
}

.bg-gradient-qc {
  background: linear-gradient(125deg, #d3d2cd, #e3e4de, #fdfdfd, #e3e4de, #d3d2cd) !important;
  border: 2px solid #ffd36c;
  padding: 30px !important;
  margin-bottom: 50px;
  box-shadow: 0px 0px 50px 0px rgb(0 0 0 / 50%);
}


.bg-gradient-db {
  background: linear-gradient(115deg, rgba(245, 228, 177, 1) 0%, rgba(153, 135, 95, 1) 51%, rgba(231, 214, 164, 1) 80%, rgba(169, 151, 109, 1) 100%) !important;
  border: 2px solid #ffd36c;
  padding: 30px !important;
  margin-bottom: 50px;
  box-shadow: 0px 0px 50px 0px rgb(0 0 0 / 50%);
}

.bg-gradient-db3 {
  background: linear-gradient(115deg, #e4d8be, #c7c4a6, #e4d8be, #cac9af, #e4d8be) !important;
  border: 2px solid #ffd36c;
  padding: 30px !important;
  margin-bottom: 50px;
  box-shadow: 0px 0px 50px 0px rgb(0 0 0 / 50%);
}

.bg-gradient-of {
  background: linear-gradient(#FFD36C87, #FFFFFF87);
}

.gold-ombre {
  background: -webkit-linear-gradient(105deg, rgba(153, 153, 102, 1) 0%, rgba(245, 228, 177, 1) 27%, rgba(153, 135, 95, 1) 51%, rgba(231, 214, 164, 1) 80%, rgba(169, 151, 109, 1) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}


.flex-container {
  display: flex;
  flex-direction: row;
}

.flex-container2 {
  display: flex;
  flex-direction: row;
}


@media (max-width: 800px) {
  .flex-container {
    flex-direction: column;
  }

  .flex-container2 {
    flex-direction: column;
  }
}

.sticky {
  position: sticky;
  top: 0;
  margin-bottom: auto;
}


.royal {
  color: #1a1f56 !important;
}

.bundle-header {
  font-size: 30px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0 0 30px 0;
  font-family: 'Poppins', sans-serif;
}

.bg-royal {
  background-color: #1a1f56 !important;
}

/*
  
      .text-center {
        text-align: center!important;
      }
      
      */

.card {
  font-family: poppins, sans-serif;
  color: #1a1f56;
  font-weight: 400;
}


.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  border-bottom: 1px solid rgba(0, 0, 0, .125);
}

h4 {
  font-weight: 600;
  font-size: 18px;
}


:root {
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #007bff;
  --secondary: #6c757d;
  --success: #28a745;
  --info: #17a2b8;
  --warning: #ffc107;
  --danger: #dc3545;
  --light: #f8f9fa;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}


.card {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(255, 211, 108, 1);
  border-radius: 0.25rem;
}

.card>hr {
  margin-right: 0;
  margin-left: 0;
}

.card>.list-group:first-child .list-group-item:first-child {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.card>.list-group:last-child .list-group-item:last-child {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.card-body {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
  color: #444;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}

.card-link+.card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-header+.list-group .list-group-item:first-child {
  border-top: 0;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
}

.card-img {
  width: 100%;
  border-radius: calc(0.25rem - 1px);
}

.card-img-top {
  width: 100%;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card-img-bottom {
  width: 100%;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-deck {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
}

.card-deck .card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-deck {
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }

  .card-deck .card {
    display: -ms-flexbox;
    display: flex;
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    -ms-flex-direction: column;
    flex-direction: column;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
}

.card-group>.card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-group {
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
  }

  .card-group>.card {
    -ms-flex: 1 0 0%;
    flex: 1 0 0%;
    margin-bottom: 0;
  }

  .card-group>.card+.card {
    margin-left: 0;
    border-left: 0;
  }

  .card-group>.card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .card-group>.card:not(:last-child) .card-img-top,
  .card-group>.card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }

  .card-group>.card:not(:last-child) .card-img-bottom,
  .card-group>.card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }

  .card-group>.card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .card-group>.card:not(:first-child) .card-img-top,
  .card-group>.card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }

  .card-group>.card:not(:first-child) .card-img-bottom,
  .card-group>.card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 0.75rem;
}

@media (min-width: 576px) {
  .card-columns {
    -webkit-column-count: 3;
    -moz-column-count: 3;
    column-count: 3;
    -webkit-column-gap: 1.25rem;
    -moz-column-gap: 1.25rem;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }

  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}



.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 70%;
}

.center2 {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

.DialogInsightFormDiv input[type="radio"] {
  top: unset;
  width:24px;
  height:24px;
	border-color:#FFF;
	vertical-align: middle!important;
}

</style>